export const BizAidMobile = () => (
  <svg
    className="bizaid mobile"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 138.76 784.53"
  >
    <line className="cls-1" x1="69.38" y1="784.53" x2="69.38" y2="112.53" />
    <path
      className="cls-1"
      d="M1,682.8V723a28.21,28.21,0,0,0,28.22,28.21H69.38V711A28.22,28.22,0,0,0,41.16,682.8Z"
    />
    <text className="cls-2" transform="translate(21.73 702.67)">
      <tspan className="cls-3">A</tspan>
      <tspan className="cls-4" x="3.43" y="0">
        IT
      </tspan>
      <tspan className="cls-5" x="8.29" y="0">
        K
      </tspan>
      <tspan className="cls-6" x="12.03" y="0">
        I
      </tspan>
      <tspan x="13.98" y="0">
        N{' '}
      </tspan>
      <tspan className="cls-7" x="18.9" y="0">
        C
      </tspan>
      <tspan className="cls-8" x="22.4" y="0">
        O
      </tspan>
      <tspan x="25.94" y="0">
        .
      </tspan>
    </text>
    <text className="cls-2" transform="translate(21.13 735.61)">
      <tspan className="cls-9">2</tspan>
      <tspan x="3.38" y="0">
        0{' '}
      </tspan>
      <tspan className="cls-10" x="7.84" y="0">
        G
      </tspan>
      <tspan className="cls-11" x="11.33" y="0">
        R
      </tspan>
      <tspan className="cls-3" x="15.02" y="0">
        AN
      </tspan>
      <tspan className="cls-12" x="22.48" y="0">
        T
      </tspan>
      <tspan className="cls-13" x="25.38" y="0">
        S
      </tspan>
    </text>
    <text className="cls-14" transform="translate(9.91 717.62)">
      <tspan className="cls-15">$</tspan>
      <tspan className="cls-16" x="6.66" y="0">
        2
      </tspan>
      <tspan className="cls-17" x="13.19" y="0">
        00
      </tspan>
      <tspan className="cls-18" x="26.82" y="0">
        ,
      </tspan>
      <tspan className="cls-17" x="30.09" y="0">
        00
      </tspan>
      <tspan x="43.72" y="0">
        0
      </tspan>
    </text>
    <line className="cls-1" x1="10.25" y1="724.07" x2="59.9" y2="724.07" />
    <path
      className="cls-1"
      d="M1,551.94V592.1a28.22,28.22,0,0,0,28.22,28.22H69.38V580.16a28.21,28.21,0,0,0-28.22-28.22Z"
    />
    <text className="cls-2" transform="translate(23.29 571.81)">
      <tspan className="cls-7">C</tspan>
      <tspan className="cls-19" x="3.5" y="0">
        O
      </tspan>
      <tspan className="cls-20" x="7.03" y="0">
        O
      </tspan>
      <tspan x="10.53" y="0">
        K{' '}
      </tspan>
      <tspan className="cls-7" x="15.16" y="0">
        C
      </tspan>
      <tspan className="cls-8" x="18.66" y="0">
        O
      </tspan>
      <tspan x="22.2" y="0">
        .
      </tspan>
    </text>
    <text className="cls-2" transform="translate(21.05 604.74)">
      <tspan className="cls-5">1</tspan>
      <tspan className="cls-13" x="2.96" y="0">
        4{' '}
      </tspan>
      <tspan className="cls-21" x="7.51" y="0">
        G
      </tspan>
      <tspan className="cls-22" x="11" y="0">
        R
      </tspan>
      <tspan className="cls-3" x="14.69" y="0">
        AN
      </tspan>
      <tspan className="cls-23" x="22.15" y="0">
        T
      </tspan>
      <tspan x="25.05" y="0">
        S
      </tspan>
    </text>
    <text className="cls-14" transform="translate(10.16 586.76)">
      <tspan className="cls-24">$</tspan>
      <tspan className="cls-25" x="6.71" y="0">
        1
      </tspan>
      <tspan className="cls-26" x="12.4" y="0">
        4
      </tspan>
      <tspan className="cls-17" x="19.51" y="0">
        0
      </tspan>
      <tspan className="cls-18" x="26.32" y="0">
        ,
      </tspan>
      <tspan className="cls-17" x="29.59" y="0">
        00
      </tspan>
      <tspan x="43.23" y="0">
        0
      </tspan>
    </text>
    <line className="cls-1" x1="10.36" y1="593.21" x2="60.02" y2="593.21" />
    <path
      className="cls-1"
      d="M1,421.07v40.17a28.21,28.21,0,0,0,28.22,28.21H69.38V449.29a28.22,28.22,0,0,0-28.22-28.22Z"
    />
    <text className="cls-2" transform="translate(11.99 440.94)">
      <tspan className="cls-27">K</tspan>
      <tspan className="cls-28" x="3.68" y="0">
        OO
      </tspan>
      <tspan className="cls-29" x="10.74" y="0">
        C
      </tspan>
      <tspan className="cls-30" x="14.2" y="0">
        H
      </tspan>
      <tspan className="cls-20" x="18.08" y="0">
        I
      </tspan>
      <tspan className="cls-27" x="20.05" y="0">
        C
      </tspan>
      <tspan className="cls-31" x="23.52" y="0">
        H
      </tspan>
      <tspan className="cls-6" x="27.39" y="0">
        I
      </tspan>
      <tspan className="cls-32" x="29.34" y="0">
        N
      </tspan>
      <tspan x="33.31" y="0">
        G{' '}
      </tspan>
      <tspan className="cls-7" x="37.75" y="0">
        C
      </tspan>
      <tspan className="cls-33" x="41.25" y="0">
        O
      </tspan>
      <tspan className="cls-13" x="44.79" y="0">
        .
      </tspan>
    </text>
    <text className="cls-2" transform="translate(21.16 473.88)">
      <tspan className="cls-34">2</tspan>
      <tspan x="3.45" y="0">
        1{' '}
      </tspan>
      <tspan className="cls-21" x="7.3" y="0">
        G
      </tspan>
      <tspan className="cls-22" x="10.78" y="0">
        R
      </tspan>
      <tspan className="cls-3" x="14.47" y="0">
        AN
      </tspan>
      <tspan className="cls-23" x="21.94" y="0">
        T
      </tspan>
      <tspan x="24.84" y="0">
        S
      </tspan>
    </text>
    <text className="cls-35" transform="translate(10.5 455.89)">
      $
      <tspan className="cls-36" x="6.66" y="0">
        2
      </tspan>
      <tspan className="cls-37" x="13.33" y="0">
        1
      </tspan>
      <tspan className="cls-17" x="18.84" y="0">
        0
      </tspan>
      <tspan className="cls-18" x="25.65" y="0">
        ,
      </tspan>
      <tspan className="cls-17" x="28.92" y="0">
        00
      </tspan>
      <tspan className="cls-38" x="42.56" y="0">
        0
      </tspan>
    </text>
    <line className="cls-1" x1="10.36" y1="462.34" x2="60.02" y2="462.34" />
    <path
      className="cls-1"
      d="M1,290.21v40.16a28.22,28.22,0,0,0,28.22,28.22H69.38V318.43a28.21,28.21,0,0,0-28.22-28.22Z"
    />
    <text className="cls-2" transform="translate(9.08 310.08)">
      <tspan className="cls-32">N</tspan>
      <tspan className="cls-20" x="3.97" y="0">
        O
      </tspan>
      <tspan className="cls-39" x="7.47" y="0">
        R
      </tspan>
      <tspan className="cls-40" x="11.14" y="0">
        T
      </tspan>
      <tspan x="13.97" y="0">
        H{' '}
      </tspan>
      <tspan className="cls-41" x="18.83" y="0">
        S
      </tspan>
      <tspan className="cls-42" x="22.29" y="0">
        T
      </tspan>
      <tspan className="cls-13" x="24.9" y="0">
        .{' '}
      </tspan>
      <tspan className="cls-43" x="27.56" y="0">
        L
      </tspan>
      <tspan className="cls-28" x="30.25" y="0">
        O
      </tspan>
      <tspan className="cls-44" x="33.78" y="0">
        U
      </tspan>
      <tspan className="cls-45" x="37.29" y="0">
        I
      </tspan>
      <tspan x="39.29" y="0">
        S{' '}
      </tspan>
      <tspan className="cls-46" x="43.58" y="0">
        C
      </tspan>
      <tspan className="cls-8" x="47.08" y="0">
        O
      </tspan>
      <tspan x="50.62" y="0">
        .
      </tspan>
    </text>
    <text className="cls-2" transform="translate(19.58 343.01)">
      <tspan className="cls-47">1</tspan>
      <tspan className="cls-5" x="2.95" y="0">
        1
      </tspan>
      <tspan className="cls-13" x="5.91" y="0">
        4{' '}
      </tspan>
      <tspan className="cls-21" x="10.46" y="0">
        G
      </tspan>
      <tspan className="cls-22" x="13.94" y="0">
        R
      </tspan>
      <tspan className="cls-3" x="17.64" y="0">
        AN
      </tspan>
      <tspan className="cls-23" x="25.1" y="0">
        T
      </tspan>
      <tspan x="28" y="0">
        S
      </tspan>
    </text>
    <text className="cls-14" transform="translate(6.18 325.03)">
      <tspan className="cls-24">$</tspan>
      <tspan className="cls-48" x="6.71" y="0">
        1
      </tspan>
      <tspan className="cls-49" x="12.3" y="0">
        ,
      </tspan>
      <tspan className="cls-50" x="14.67" y="0">
        1
      </tspan>
      <tspan className="cls-26" x="20.36" y="0">
        4
      </tspan>
      <tspan className="cls-17" x="27.47" y="0">
        0
      </tspan>
      <tspan className="cls-51" x="34.29" y="0">
        ,
      </tspan>
      <tspan className="cls-17" x="37.56" y="0">
        00
      </tspan>
      <tspan x="51.19" y="0">
        0
      </tspan>
    </text>
    <line className="cls-1" x1="10.36" y1="331.48" x2="60.02" y2="331.48" />
    <path
      className="cls-1"
      d="M1,159.34v40.17a28.21,28.21,0,0,0,28.22,28.21H69.38V187.56a28.22,28.22,0,0,0-28.22-28.22Z"
    />
    <text className="cls-2" transform="translate(14.27 179.21)">
      <tspan className="cls-40">T</tspan>
      <tspan className="cls-28" x="2.83" y="0">
        R
      </tspan>
      <tspan className="cls-52" x="6.4" y="0">
        I
      </tspan>
      <tspan className="cls-28" x="8.35" y="0">
        B
      </tspan>
      <tspan className="cls-53" x="12.04" y="0">
        A
      </tspan>
      <tspan x="15.47" y="0">
        L{' '}
      </tspan>
      <tspan className="cls-54" x="19.02" y="0">
        N
      </tspan>
      <tspan className="cls-55" x="23.06" y="0">
        A
      </tspan>
      <tspan className="cls-40" x="26.31" y="0">
        T
      </tspan>
      <tspan className="cls-20" x="29.13" y="0">
        IO
      </tspan>
      <tspan className="cls-56" x="34.61" y="0">
        N
      </tspan>
      <tspan x="38.61" y="0">
        S
      </tspan>
    </text>
    <text className="cls-2" transform="translate(24.61 212.15)">
      1{' '}
      <tspan className="cls-21" x="3.85" y="0">
        G
      </tspan>
      <tspan className="cls-22" x="7.33" y="0">
        R
      </tspan>
      <tspan className="cls-3" x="11.02" y="0">
        AN
      </tspan>
      <tspan x="18.49" y="0">
        T
      </tspan>
    </text>
    <text className="cls-14" transform="translate(13.81 194.16)">
      <tspan className="cls-24">$</tspan>
      <tspan className="cls-37" x="6.71" y="0">
        1
      </tspan>
      <tspan className="cls-17" x="12.21" y="0">
        0
      </tspan>
      <tspan className="cls-18" x="19.03" y="0">
        ,
      </tspan>
      <tspan className="cls-17" x="22.3" y="0">
        00
      </tspan>
      <tspan x="35.93" y="0">
        0
      </tspan>
    </text>
    <line className="cls-1" x1="10.36" y1="200.61" x2="60.02" y2="200.61" />
    <path
      className="cls-1"
      d="M69.38,1.41l-41,41.06a40.78,40.78,0,0,0,0,57.69l41.05,41.06,41.06-41.06a40.79,40.79,0,0,0,0-57.69Z"
    />
    <text className="cls-57" transform="translate(61.85 54.42)">
      <tspan className="cls-58">TO</tspan>
      <tspan className="cls-59" x="7.51" y="0">
        T
      </tspan>
      <tspan className="cls-60" x="10.56" y="0">
        A
      </tspan>
      <tspan x="14.56" y="0">
        L
      </tspan>
    </text>
    <text className="cls-57" transform="translate(52.11 93.28)">
      <tspan className="cls-61">3</tspan>
      <tspan className="cls-62" x="4" y="0">
        8
      </tspan>
      <tspan x="8.2" y="0">
        1{' '}
      </tspan>
      <tspan className="cls-63" x="12.74" y="0">
        G
      </tspan>
      <tspan className="cls-64" x="16.8" y="0">
        R
      </tspan>
      <tspan className="cls-60" x="21.1" y="0">
        AN
      </tspan>
      <tspan className="cls-65" x="29.8" y="0">
        T
      </tspan>
      <tspan x="33.17" y="0">
        S
      </tspan>
    </text>
    <text className="cls-66" transform="translate(35.47 72.06)">
      <tspan className="cls-67">$</tspan>
      <tspan className="cls-68" x="7.84" y="0">
        3
      </tspan>
      <tspan className="cls-69" x="15.69" y="0">
        ,
      </tspan>
      <tspan className="cls-70" x="19.56" y="0">
        8
      </tspan>
      <tspan className="cls-71" x="27.78" y="0">
        1
      </tspan>
      <tspan className="cls-72" x="34.26" y="0">
        0
      </tspan>
      <tspan className="cls-73" x="42.29" y="0">
        ,
      </tspan>
      <tspan className="cls-74" x="46.13" y="0">
        00
      </tspan>
      <tspan x="62.19" y="0">
        0
      </tspan>
    </text>
    <line className="cls-1" x1="41.31" y1="79.67" x2="99.89" y2="79.67" />
    <path
      className="cls-1"
      d="M137.76,617.37H97.6a28.22,28.22,0,0,0-28.22,28.22v40.16h40.16a28.21,28.21,0,0,0,28.22-28.22Z"
    />
    <text className="cls-75" transform="translate(86.98 637.24)">
      C
      <tspan className="cls-3" x="3.5" y="0">
        A
      </tspan>
      <tspan className="cls-4" x="6.93" y="0">
        L
      </tspan>
      <tspan className="cls-39" x="9.59" y="0">
        R
      </tspan>
      <tspan className="cls-76" x="13.26" y="0">
        T
      </tspan>
      <tspan className="cls-20" x="16.12" y="0">
        O
      </tspan>
      <tspan className="cls-77" x="19.62" y="0">
        N{' '}
      </tspan>
      <tspan className="cls-7" x="24.54" y="0">
        C
      </tspan>
      <tspan className="cls-33" x="28.04" y="0">
        O
      </tspan>
      <tspan className="cls-13" x="31.58" y="0">
        .
      </tspan>
    </text>
    <text className="cls-2" transform="translate(89.72 670.17)">
      <tspan className="cls-78">2</tspan>
      <tspan className="cls-13" x="3.43" y="0">
        7{' '}
      </tspan>
      <tspan className="cls-10" x="6.94" y="0">
        G
      </tspan>
      <tspan className="cls-11" x="10.42" y="0">
        R
      </tspan>
      <tspan className="cls-3" x="14.11" y="0">
        AN
      </tspan>
      <tspan className="cls-23" x="21.58" y="0">
        T
      </tspan>
      <tspan x="24.48" y="0">
        S
      </tspan>
    </text>
    <text className="cls-35" transform="translate(79.16 652.19)">
      $
      <tspan className="cls-79" x="6.66" y="0">
        2
      </tspan>
      <tspan className="cls-80" x="13.29" y="0">
        7
      </tspan>
      <tspan className="cls-17" x="18.27" y="0">
        0
      </tspan>
      <tspan className="cls-18" x="25.09" y="0">
        ,
      </tspan>
      <tspan className="cls-81" x="28.36" y="0">
        00
      </tspan>
      <tspan className="cls-38" x="41.99" y="0">
        0
      </tspan>
    </text>
    <line className="cls-1" x1="78.75" y1="658.64" x2="128.4" y2="658.64" />
    <path
      className="cls-1"
      d="M137.76,486.5H97.6a28.23,28.23,0,0,0-28.22,28.22v40.17h40.16a28.22,28.22,0,0,0,28.22-28.22Z"
    />
    <text className="cls-2" transform="translate(89.58 506.38)">
      <tspan className="cls-82">I</tspan>
      <tspan className="cls-83" x="2.03" y="0">
        T
      </tspan>
      <tspan className="cls-53" x="4.68" y="0">
        AS
      </tspan>
      <tspan className="cls-84" x="11.5" y="0">
        C
      </tspan>
      <tspan x="15.01" y="0">
        A{' '}
      </tspan>
      <tspan className="cls-46" x="19.32" y="0">
        C
      </tspan>
      <tspan className="cls-8" x="22.82" y="0">
        O
      </tspan>
      <tspan x="26.37" y="0">
        .
      </tspan>
    </text>
    <text className="cls-2" transform="translate(89.21 539.31)">
      <tspan className="cls-85">6</tspan>
      <tspan x="3.5" y="0">
        0{' '}
      </tspan>
      <tspan className="cls-21" x="7.96" y="0">
        G
      </tspan>
      <tspan className="cls-11" x="11.45" y="0">
        R
      </tspan>
      <tspan className="cls-53" x="15.14" y="0">
        AN
      </tspan>
      <tspan className="cls-12" x="22.6" y="0">
        T
      </tspan>
      <tspan x="25.5" y="0">
        S
      </tspan>
    </text>
    <text className="cls-14" transform="translate(78.22 521.32)">
      <tspan className="cls-25">$</tspan>
      <tspan className="cls-48" x="6.57" y="0">
        6
      </tspan>
      <tspan className="cls-17" x="13.33" y="0">
        00
      </tspan>
      <tspan className="cls-18" x="26.96" y="0">
        ,
      </tspan>
      <tspan className="cls-17" x="30.23" y="0">
        00
      </tspan>
      <tspan x="43.86" y="0">
        0
      </tspan>
    </text>
    <line className="cls-1" x1="78.75" y1="527.77" x2="128.4" y2="527.77" />
    <path
      className="cls-1"
      d="M137.76,355.64H97.6a28.22,28.22,0,0,0-28.22,28.22V424h40.16a28.21,28.21,0,0,0,28.22-28.22Z"
    />
    <text className="cls-2" transform="translate(89.85 375.51)">
      <tspan className="cls-86">L</tspan>
      <tspan className="cls-53" x="2.77" y="0">
        AK
      </tspan>
      <tspan className="cls-13" x="9.94" y="0">
        E{' '}
      </tspan>
      <tspan className="cls-7" x="13.67" y="0">
        C
      </tspan>
      <tspan className="cls-8" x="17.17" y="0">
        O
      </tspan>
      <tspan x="20.71" y="0">
        .
      </tspan>
    </text>
    <text className="cls-2" transform="translate(89.47 408.44)">
      <tspan className="cls-87">1</tspan>
      <tspan x="2.88" y="0">
        0{' '}
      </tspan>
      <tspan className="cls-21" x="7.34" y="0">
        G
      </tspan>
      <tspan className="cls-22" x="10.82" y="0">
        R
      </tspan>
      <tspan className="cls-3" x="14.52" y="0">
        AN
      </tspan>
      <tspan className="cls-23" x="21.98" y="0">
        T
      </tspan>
      <tspan x="24.88" y="0">
        S
      </tspan>
    </text>
    <text className="cls-14" transform="translate(78.48 390.46)">
      <tspan className="cls-24">$</tspan>
      <tspan className="cls-37" x="6.71" y="0">
        1
      </tspan>
      <tspan className="cls-17" x="12.21" y="0">
        00
      </tspan>
      <tspan className="cls-18" x="25.84" y="0">
        ,
      </tspan>
      <tspan className="cls-17" x="29.11" y="0">
        00
      </tspan>
      <tspan x="42.75" y="0">
        0
      </tspan>
    </text>
    <line className="cls-1" x1="79.01" y1="396.91" x2="128.66" y2="396.91" />
    <path
      className="cls-1"
      d="M137.76,224.77H97.6A28.23,28.23,0,0,0,69.38,253v40.17h40.16a28.22,28.22,0,0,0,28.22-28.22Z"
    />
    <text className="cls-2" transform="translate(78.74 244.65)">
      <tspan className="cls-3">S</tspan>
      <tspan className="cls-19" x="3.4" y="0">
        O
      </tspan>
      <tspan className="cls-88" x="6.93" y="0">
        U
      </tspan>
      <tspan className="cls-40" x="10.53" y="0">
        T
      </tspan>
      <tspan x="13.35" y="0">
        H{' '}
      </tspan>
      <tspan className="cls-41" x="18.21" y="0">
        S
      </tspan>
      <tspan className="cls-42" x="21.67" y="0">
        T
      </tspan>
      <tspan x="24.28" y="0">
        .{' '}
      </tspan>
      <tspan className="cls-43" x="26.95" y="0">
        L
      </tspan>
      <tspan className="cls-28" x="29.63" y="0">
        O
      </tspan>
      <tspan className="cls-89" x="33.16" y="0">
        U
      </tspan>
      <tspan x="36.73" y="0">
        S{' '}
      </tspan>
      <tspan className="cls-46" x="41.02" y="0">
        C
      </tspan>
      <tspan className="cls-8" x="44.52" y="0">
        O
      </tspan>
      <tspan x="48.06" y="0">
        .
      </tspan>
    </text>
    <text className="cls-2" transform="translate(87.96 277.58)">
      <tspan className="cls-47">1</tspan>
      <tspan className="cls-5" x="2.95" y="0">
        1
      </tspan>
      <tspan className="cls-13" x="5.91" y="0">
        4{' '}
      </tspan>
      <tspan className="cls-21" x="10.46" y="0">
        G
      </tspan>
      <tspan className="cls-22" x="13.94" y="0">
        R
      </tspan>
      <tspan className="cls-3" x="17.64" y="0">
        AN
      </tspan>
      <tspan className="cls-23" x="25.1" y="0">
        T
      </tspan>
      <tspan x="28" y="0">
        S
      </tspan>
    </text>
    <text className="cls-14" transform="translate(74.56 259.59)">
      <tspan className="cls-24">$</tspan>
      <tspan className="cls-48" x="6.71" y="0">
        1
      </tspan>
      <tspan className="cls-49" x="12.3" y="0">
        ,
      </tspan>
      <tspan className="cls-50" x="14.67" y="0">
        1
      </tspan>
      <tspan className="cls-26" x="20.36" y="0">
        4
      </tspan>
      <tspan className="cls-17" x="27.47" y="0">
        0
      </tspan>
      <tspan className="cls-51" x="34.29" y="0">
        ,
      </tspan>
      <tspan className="cls-17" x="37.56" y="0">
        00
      </tspan>
      <tspan x="51.19" y="0">
        0
      </tspan>
    </text>
    <line className="cls-1" x1="78.75" y1="266.04" x2="128.4" y2="266.04" />
    <path
      className="cls-1"
      d="M69.38,589.21a6.7,6.7,0,0,1,2-4.73,5.37,5.37,0,0,1,7.58,0,4.29,4.29,0,0,1,0,6.06,3.43,3.43,0,0,1-4.85,0,2.75,2.75,0,0,1,0-3.88,2.18,2.18,0,0,1,3.1,0"
    />
    <path
      className="cls-1"
      d="M69.38,181.75a6.71,6.71,0,0,1,2-4.74,5.37,5.37,0,0,1,7.58,0,4.29,4.29,0,0,1,0,6.06,3.43,3.43,0,0,1-4.85,0,2.75,2.75,0,0,1,0-3.88,2.2,2.2,0,0,1,3.1,0"
    />
    <path
      className="cls-1"
      d="M69.38,395.56a6.66,6.66,0,0,0-2-4.73,5.37,5.37,0,0,0-7.58,0,4.29,4.29,0,0,0,0,6.06,3.43,3.43,0,0,0,4.85,0,2.75,2.75,0,0,0,0-3.88,2.18,2.18,0,0,0-3.1,0"
    />
    <path className="cls-1" d="M64,526.05a5.42,5.42,0,0,1,5.42,5.42" />
    <path className="cls-1" d="M64,152.86a5.43,5.43,0,0,1,5.42,5.43" />
    <path className="cls-1" d="M69.38,308.93a5.42,5.42,0,0,1,5.42-5.42" />
    <path className="cls-1" d="M74.8,776.2a5.42,5.42,0,0,1-5.42-5.42" />
  </svg>
);
